var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "chevronUp_svg__svg-safari-fix",
  viewBox: "0 0 24 24",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.98 16.56c-.25 0-.51-.1-.7-.29a.987.987 0 0 1 0-1.41l7.08-7.16a1 1 0 0 1 .71-.3 1 1 0 0 1 .71.3l6.96 7.11c.39.39.38 1.03-.02 1.41a.987.987 0 0 1-1.41-.02l-6.25-6.39-6.37 6.43c-.2.2-.45.3-.71.3z"
})));
export default SvgChevronUp;